"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Death_1 = require("../../core/effects/core/Death");
const EffectType_1 = require("../../core/effects/EffectType");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
let Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript = class Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        switch (event.args.__typeName) {
            case "Healed": {
                if (!container.isFullHealth(event.subject)) {
                    return;
                }
                const signets = container.getEffectsOfType(event.subject, EffectType_1.EffectType.BloodSignet);
                sequence = sequence.pushSequence("parallel");
                signets.forEach(signet => container.cancelEffect(sequence, signet));
                return;
            }
            case "TurnStarted": {
                handler.meta.elapsedTurns = handler.meta.elapsedTurns || 0;
                handler.meta.elapsedTurns++;
                if (handler.meta.elapsedTurns === 1) {
                    container.applyFloatingText(sequence, event.subject, "I don't feel so well...", "red", "medium");
                    return;
                }
                else if (handler.meta.elapsedTurns === 2) {
                    container.applyFloatingText(sequence, event.subject, "Everything is... getting... blurry...", "red", "medium");
                    return;
                }
                container.applyFloatingText(sequence, event.subject, "It's too late for me...", "red", "large");
                container.applyEffect(sequence, handler.args.scriptArgs.createdBy, event.subject, new Death_1.DeathEffectArgs(), Duration_1.Duration.Permanent);
                const [nextTargetId] = container.selectLivingTargets(handler.args.scriptArgs.createdBy, Target_1.Target.AllEnemies)
                    .sort((a, b) => container.getAttributeScore(a, enums_1.AttributeType.Health) - container.getAttributeScore(b, enums_1.AttributeType.Health));
                if (!nextTargetId) {
                    return;
                }
                container.applyDebuff({
                    sequence,
                    attackerId: handler.args.scriptArgs.createdBy,
                    targetId: nextTargetId,
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true,
                    effect: new core_1.BloodSignetEffectArgs,
                    onApplied(sequence) {
                        sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(nextTargetId, "feet"), "FallingBloodMissle"));
                    }
                });
                return;
            }
        }
    }
};
Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_BloodSignet_OnHealedOnTurnStarted")
], Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript);
exports.Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript = Effect_BloodSignet_OnHealedOnTurnStartedEventHandlerScript;
